// https://ads.tiktok.com/marketing_api/docs?rid=5ipocbxyw8v&id=1701890973258754
import { getQuery } from '@/utils/utils'

// 只有在链接 source=TT 下使用TikTok pixel
function isCanLoad() {
  const source = getQuery('source') || ''
  const result = ['TT'].includes(source)
  return result && process.client
}

function isTtSDK() {
  const ohead = document.querySelector('head')
  const TiktokId = ohead.querySelector('#__tiktok__id')
  return !!TiktokId
}

export function initTTPixel() {
  if (isTtSDK()) return
  if (isCanLoad()) {
    const tt_pixel_id = 'C8JD4B8B3BVP1792KSB0'

    !(function (w, d, t) {
      w.TiktokAnalyticsObject = t
      var ttq = (w[t] = w[t] || [])
      ;(ttq.methods = [
        'page',
        'track',
        'identify',
        'instances',
        'debug',
        'on',
        'off',
        'once',
        'ready',
        'alias',
        'group',
        'enableCookie',
        'disableCookie',
      ]),
        (ttq.setAndDefer = function (t, e) {
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
          }
        })
      for (var i = 0; i < ttq.methods.length; i++)
        ttq.setAndDefer(ttq, ttq.methods[i])
      ;(ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
          ttq.setAndDefer(e, ttq.methods[n])
        return e
      }),
        (ttq.load = function (e, n) {
          var i = 'https://analytics.tiktok.com/i18n/pixel/events.js'
          ;(ttq._i = ttq._i || {}),
            (ttq._i[e] = []),
            (ttq._i[e]._u = i),
            (ttq._t = ttq._t || {}),
            (ttq._t[e] = +new Date()),
            (ttq._o = ttq._o || {}),
            (ttq._o[e] = n || {})
          var o = document.createElement('script')
          ;(o.type = 'text/javascript'),
            (o.async = !0),
            (o.src = i + '?sdkid=' + e + '&lib=' + t)
          var a = document.getElementsByTagName('script')[0]
          o.id = '__tiktok__id'
          a.parentNode.insertBefore(o, a)
        })
      ttq.load(tt_pixel_id)
      ttq.page()
    })(window, document, 'ttq')
  }
}

export const tt_track_eventCommon = ({
  eventName = '',
  content_type = 'product',
  content_id = '',
  content_category = '',
  currency = '',
  value = 0,
  quantity = 1,
  price = 0,
}) => {
  if (isCanLoad() && eventName && window.ttq) {
    ttq &&
      ttq.track(eventName, {
        content_type,
        content_id,
        content_category,
        currency,
        value,
        quantity,
        price,
      })
  }
}
